import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { getBackendUrl } from "@/utils/util";

export default function API_Calls_Template() {
  const { apiCall } = API_Call_Handler();
  const backendUrl = getBackendUrl();
  const { queryParamsAndHeaders } = API_Calls_Utils();

  const processTemplateMapping = async (
    affiliate,
    templateData,
    affiliateFileData,
    use
  ) => {
    const queryParams = {
      template: `${templateData.created}/${templateData.name}.templ`,
      data: `${affiliateFileData.created}/${affiliateFileData.name}`,
      affiliate: affiliate.toUpperCase(),
      use,
    };

    const { headers, queryString } = await queryParamsAndHeaders(queryParams);

    return await apiCall({
      url: `${backendUrl}/api/process?${queryString}`,
      method: "POST",
      headers,
    });
  };

  async function downloadTemplate(affiliate, filename, created) {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      name: filename,
      created,
    });

    return await apiCall({
      url: `${backendUrl}/api/template?${queryString}`,
      responseType: "blob",
      headers,
    });
  }

  async function fetchTemplates(affiliate) {
    const { headers, queryString } = await queryParamsAndHeaders({ affiliate });

    const data = await apiCall({
      url: `${backendUrl}/api/templates?${queryString}`,
      headers,
    });

    // Remove .templ extension from all template names, otherwise when they are saved, .templs will continue to accrue and cause errors
    data.data = data.data?.map((item) => {
      item.name = item.name.replace(new RegExp(".templ" + "$"), "");
      return item;
    });
    return data;
  }

  async function deleteTemplate(affiliate, name, created) {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      name,
      created,
    });
    return await apiCall({
      url: `${backendUrl}/api/template?${queryString}`,
      method: "DELETE",
      headers,
    });
  }

  const postTemplate = async (affiliate, name, updatedTemplate, use) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      name,
      use,
    });

    return apiCall({
      url: `${backendUrl}/api/template/?${queryString}`,
      method: "POST",
      data: updatedTemplate,
      headers,
    });
  };

  const getExistingTemplate = async (affiliate, filename, created) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      name: filename,
      created,
    });
    return apiCall({
      url: `${backendUrl}/api/template?${queryString}`,
      headers,
    });
  };

  async function getRawTemplate(affiliate, filename, created) {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      name: filename,
      created,
    });

    return await apiCall({
      url: `${backendUrl}/api/template/raw?${queryString}`,
      headers,
    });
  }

  async function fetchNewTemplate() {
    return apiCall({
      url: `${backendUrl}/api/template/new`,
    });
  }

  async function getFormulae() {
    return apiCall({
      url: `${backendUrl}/api/formulae`,
    });
  }

  async function getPriority() {
    return apiCall({
      url: `${backendUrl}/api/template/priority`,
    });
  }

  return {
    processTemplateMapping,
    downloadTemplate,
    fetchTemplates,
    deleteTemplate,
    postTemplate,
    getExistingTemplate,
    getRawTemplate,
    fetchNewTemplate,
    getFormulae,
    getPriority,
  };
}
